<template>
  <div>
    <TopNavbar title="编辑"></TopNavbar>
    <div class="edit-container">
      <div class="avatar-edit-container" v-if="userInfo && userInfo.id">
        <div>头像</div>
        <div class="right-text">
          <div class="cropper">
            <img :src="img" class="img"/>
            <Cropper :option="option" @getbase64Data="getbase64Data" @getFile="getFile"
                        class="crop-item"></Cropper>
          </div>
          <Icon name="arrow" v-if="!updatingAvatar"></Icon>
          <Loading size="16" color="black" v-else></Loading>
        </div>
      </div>
      <div class="nickname-edit-container" @click="onShowUpdateNickname">
        <div>昵称</div>
        <div class="right-text">
          <div>{{userNickname}}</div>
          <Icon :name="updatingNickname?'clock-o':'arrow'"></Icon>
        </div>
      </div>
    </div>
    <Popup v-model="showUpdatePopup" position="bottom">
      <div class="update-nickname-field">
        <Field
            v-model="userNickname"
            maxlength="15"
            placeholder="昵称"
            autofocus
        >
          <template #button>
            <Button size="small" type="warning" @click="onUpdateNickname">确定</Button>
          </template>
        </Field>
      </div>
    </Popup>
  </div>
</template>

<script>
  import {Icon, Popup, Field, Button, Toast, Loading} from "vant"
  import Cropper from "../common/Cropper"
  import TopNavbar from "../common/TopNavbar";

  export default {
    name: "EditProfile",
    components: {
      Popup, Field, Button,
      TopNavbar,
      Loading,
      Cropper, Icon
    },
    data() {
      return {
        showUpdatePopup: false,
        userInfo: {},
        option: {
          "ceilbutton": true
        },
        img: "",
        file: {},
        newUri: "",
        newUrl: "",
        userNickname: "",

        updatingAvatar: false,
        updatingNickname: false,
      }
    },
    mounted() {
      this.getCachedUserInfo()
    },
    methods: {
      getCachedUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          this.userInfo = data
          this.img = data.avatar_url
          this.userNickname = data.nickname
        }, () => {
        })
      },

      async onUpdateNickname() {
        this.showUpdatePopup = false
        if (!this.userNickname) {
          return
        }

        this.updatingNickname = true
        let params = {
          "nickname": this.userNickname
        }
        await this.$store.dispatch("UpdateAccountMine", params).then((data)=> {
          if (data.code === 0) {
            Toast("更新成功")
          } else if (data.code === 20001) {
            Toast("昵称重复")
          }
        }, ()=> {
        })
        this.updatingNickname = false
      },

      onShowUpdateNickname() {
        this.showUpdatePopup = true
      },

      getbase64Data(data) {
        this.img = data;
      },

      getFile(file) {
        this.file = file
      },

      async onAfterRead(file) {
        let params = new FormData()
        params.append('file', file)
        params.append("bucket", "bos-hkfile")
        params.append("source", "avatar")
        file.status = "uploading"
        this.updatingAvatar = true
        let newUri = ""

        await this.$store.dispatch("UploadImage", params).then((data) => {
          if (data.code === 0) {
            file.status = "done"
            file.uri = data.data.uri
            file.url = data.data.image_url
            newUri = data.data.uri
          } else {
            file.status = "failed"
          }
        }, () => {
          file.status = "failed"
        })

        if (newUri) {
          await this.updateUserAvatarUri(newUri)
        }
        this.updatingAvatar = false
      },

      async updateUserAvatarUri(uri) {
        if (!uri) {
          return
        }
        let params = {
          "avatar_uri": uri,
        }
        await this.$store.dispatch("UpdateAccountMine", params).then((data) => {
          if (data.code === 0) {
          }
        }, () => {
        })
      }
    },
    watch: {
      file() {
        this.onAfterRead(this.file)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .edit-container {
    background: #f2f2f2;
    padding-top: 54px;

    font-size: 16px;
  }

  .avatar-edit-container {
    background: white;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nickname-edit-container {
    border-bottom: 1px solid #f2f2f2;
    margin-top: 5px;
    background: white;
    padding: 12px 12px;
    min-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .right-text {
    display: flex;
    align-items: center;
  }

  .avatar-raw {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;

    img {
      width: 100%;
    }
  }

  .cropper {
    width: 80px;
    height: 80px;
    line-height: 80px;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;

    .img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
  }

  .update-nickname-field {
    padding: 15px 12px;
  }

</style>
